import { render, staticRenderFns } from "./AvailableBalance.vue?vue&type=template&id=f0cba9e2&scoped=true"
import script from "./AvailableBalance.vue?vue&type=script&setup=true&lang=ts"
export * from "./AvailableBalance.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AvailableBalance.vue?vue&type=style&index=0&id=f0cba9e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cba9e2",
  null
  
)

export default component.exports